import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const vuetify = new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#000000',
        //   secondary: '#b0bec5'
        //   anchor: '#8c9eff',
        },
      },
    },
  })
  
  export default vuetify